// Données équipe centralisées (MVP). Prochaine étape: basculer sur une source admin/DB.
export const team = [
  {
    id: 1,
    slug: 'kulina',
    name: 'ALI',
    role: 'Président fondateur',
    location: 'France',
    joinedYear: 2023,
    image: '',
    images: [],
    videos: [],
    bio: "Président fondateur de PADAID. Exilé, il a fait de son propre parcours une force d'engagement au service des personnes en difficulté, portant avec conviction la mission et les valeurs de l'association.",
    specialties: [
      'Présidence & gouvernance',
      'Engagement associatif'
    ],
    achievements: [
      'Fondation et présidence de PADAID'
    ],
    vision: [
      'Un engagement constant au service des bénéficiaires de PADAID'
    ],
    social: { linkedin: '#', twitter: '#', email: 'padaid.asso@gmail.com' }
  },
  {
    id: 2,
    slug: 'abdou',
    name: 'Abdou',
    role: 'Secrétaire général & Co-fondateur',
    location: 'France',
    joinedYear: 2023,
    image: 'https://customer-assets.emergentagent.com/job_padaid-cms/artifacts/ut5f08cp_Abdou%20%281%29.jpg',
    images: [
      'https://customer-assets.emergentagent.com/job_padaid-cms/artifacts/ut5f08cp_Abdou%20%281%29.jpg'
    ],
    videos: ['https://www.youtube.com/watch?v=hWCWbexNmrQ'],
    bio: "Arrivé en France en 2018, ayant traversé le Sahara, la Libye, puis la Méditerranée avant d'atteindre les côtes italiennes et de traverser la frontière franco-italienne. Son parcours personnel l'a sensibilisé aux réalités de l'aide humanitaire. Il apporte une compréhension profonde des besoins des populations vulnérables.",
    specialties: ['Expérience terrain', 'Sensibilisation humanitaire', 'Coordination opérationnelle'],
    achievements: [
      'Secrétaire général & Co-fondateur de PADAID',
      "Développement des programmes d'aide",
      'Expertise du parcours migratoire'
    ],
    social: { linkedin: '#', twitter: '#', email: 'abdou@padaid.com' }
  },
  {
    id: 3,
    slug: 'arbab',
    name: 'ARBAB',
    role: 'Vice-président & Co-fondateur',
    location: 'France',
    joinedYear: 2023,
    image: 'https://customer-assets.emergentagent.com/job_mvp-creator-1/artifacts/i3y9zrc0_Abdallah%20%281%29.jpg',
    images: [
      'https://customer-assets.emergentagent.com/job_mvp-creator-1/artifacts/i3y9zrc0_Abdallah%20%281%29.jpg'
    ],
    videos: [],
    bio: "Arrivé en France en 2017, traversant la Libye, la Méditerranée et la frontière Franco-italienne. Son expérience personnelle du parcours migratoire apporte à PADAID une vision authentique des défis humanitaires.",
    specialties: ['Leadership associatif', 'Coordination de projets', 'Relations communautaires'],
    achievements: [
      'Vice-président & Co-fondateur de PADAID',
      "Développement de réseaux d'entraide",
      'Coordination des actions terrain'
    ],
    social: { linkedin: '#', twitter: '#', email: 'arbab@padaid.com' }
  },
  {
    id: 4,
    slug: 'moubarak',
    name: 'Moubarak',
    role: 'Trésorier & Co-fondateur',
    location: 'France',
    joinedYear: 2023,
    image: 'https://customer-assets.emergentagent.com/job_mvp-creator-1/artifacts/p1rpbray_DSC_0280_inPixio.jpg',
    images: [
      'https://customer-assets.emergentagent.com/job_mvp-creator-1/artifacts/p1rpbray_DSC_0280_inPixio.jpg'
    ],
    videos: ['https://www.youtube.com/watch?v=9lxVY8cJRHQ'],
    bio: "Arrivé en France en 2020, après plusieurs années de tentatives, il a réussi à quitter la Libye en traversant la Méditerranée puis la frontière Franco-italienne. Son parcours de persévérance et sa détermination face aux obstacles apportent à PADAID une compréhension unique de la résilience humaine.",
    specialties: ['Gestion financière', 'Planification budgétaire', 'Transparence comptable'],
    achievements: [
      'Co-fondateur et Trésorier de PADAID',
      'Mise en place de la transparence financière',
      "Optimisation des ressources pour l'aide"
    ],
    social: { linkedin: '#', twitter: '#', email: 'moubarak@padaid.com' }
  },
  {
    id: 5,
    slug: 'hafis',
    name: 'Hafis IBRAHIM',
    role: 'Manager — chargé des réseaux sociaux',
    location: 'France',
    joinedYear: 2025,
    image: 'https://customer-assets.emergentagent.com/job_email-auth-fix-1/artifacts/xgcx6601_DSC_0369.JPG',
    images: [
      'https://customer-assets.emergentagent.com/job_email-auth-fix-1/artifacts/vivu7f7u_DSC_0360.JPG',
      'https://customer-assets.emergentagent.com/job_email-auth-fix-1/artifacts/1ykuw37c_DSC_0365.JPG',
      'https://customer-assets.emergentagent.com/job_email-auth-fix-1/artifacts/r0vbd8ef_DSC_0366.JPG',
      'https://customer-assets.emergentagent.com/job_email-auth-fix-1/artifacts/iaymb1t4_DSC_0367.JPG',
      'https://customer-assets.emergentagent.com/job_email-auth-fix-1/artifacts/xgcx6601_DSC_0369.JPG'
    ],
    videos: ['https://www.youtube.com/watch?v=qyRwM7ijdZE'],
    bio: "Responsable des réseaux sociaux de PADAID, il pilote la stratégie éditoriale, la production de contenus et l'engagement communautaire pour amplifier notre impact.",
    specialties: ['Stratégie social media', 'Création de contenu', 'Engagement communautaire'],
    achievements: [
      'Déploiement de la stratégie réseaux sociaux',
      "Croissance de l'audience et du taux d'engagement",
      'Coordination multi-plateformes'
    ],
    social: { linkedin: '#', twitter: '#', email: 'social@padaid.com' }
  }
];

export const findMemberBySlug = (slug) => team.find(m => m.slug === slug);